import Vue from 'vue'
import Vuex from 'vuex'
import Api from '../common/api'


Vue.use(Vuex);

const settings = {
  projectCount: 100,
  order: 'asc',
  orderBy: 'menu_order'
};

const state = {
  isLoading: true,
  gallery: null,
  project: null,
  galleryId: null,
  galleryImages: null,
  galleryThumbs: null,
  newHomes: null,
  alterations: null,
  selectedCategory: 'new-homes',
  currentImageId: 0,
  mobile: false,
  errors: [],
  debug: false
};

export default new Vuex.Store({
  state,
  mutations: {
    setGalleryId (state, id) {
      state.galleryId = id;
    },
    setGallery (state, galleryPayload) {
      state.gallery = galleryPayload;
    },
    formatImages (state, imgArr) {
      let tempArr = [];
      for (let i = 0; i < imgArr.length; i++) {
        // console.log(imgArr[ i ].type);
        if (imgArr[ i ].type === 'image') {
          tempArr.push(imgArr[ i ].url);
        } else if (imgArr[ i ].type === 'video') {
          console.log('video');
          let j = {
            type: 'video',
            url: imgArr[i].url
          }

          tempArr.push(j);
        }
      }
      state.projectImages = tempArr;
    },
    setCurrentImageId (state, imageId) {
      state.currentImageId = imageId;
    },
    clearProject (state) {
      state.project = null;
    },
    toggleLoading (state, bool) {
      state.isLoading = bool;
    },
    setMobile (state) {
      if (window.innerWidth < 768) state.mobile = true;
    },
  },
  actions: {
    checkMobile(context) {
      context.commit('setMobile');
    },
    loadGallery (context) {
      Api.get(`wp-json/wp/v2/gallery-category/${context.state.galleryId || 50}?_embed&orderby=${settings.orderBy}&order=${settings.order}&per_page=${settings.projectCount}`)
          .then(response => {
            context.commit('setGallery', response.data);
            context.commit('toggleLoading', false);
          })
          .catch(e => {
            this.errors.push(e);
            console.log(this.errors);

          });
    },
  },
  modules: {
  }
})
